import firebase from "firebase/app";

export { dateFromFB, dateToFB, saveWagonToFB, createWagonActual  }

function dateFromFB(dt, defaultDate) {
   try {
      if (!defaultDate)
         defaultDate = new Date();
      if (!dt)
         return defaultDate;
      if (dt instanceof firebase.firestore.Timestamp)
         return dt.toDate()
      else
         return new Date(dt);
   } catch (error) {
      //console.log("Unknown Date object:" + dt + " - type:" + (typeof dt) + "\n" + error);
      return defaultDate;
   }
}

function dateToFB(dt, defaultDate) {
   try {
      if (!defaultDate)
         defaultDate = firebase.firestore.Timestamp.now;
      else
         if (!(defaultDate instanceof firebase.firestore.Timestamp))
            defaultDate = firebase.firestore.Timestamp.fromDate(defaultDate);

      if (!dt)
         return defaultDate;
      if (dt instanceof firebase.firestore.Timestamp)
         return dt;
      else
         return firebase.firestore.Timestamp.fromDate(dt);
   } catch (error) {
      //console.log("Unknown Timestamp object:" + dt + " - type:" + (typeof dt) + "\n" + error);
      return defaultDate;
   }
}

function saveWagonToFB(state, wgn) {
   const ref = firebase.firestore().collection("/Users")
                        .doc(state.user.uid).collection("/wagons");
   const clone = Object.assign({}, wgn);
   delete clone.id;
   clone.lastModified = dateToFB(wgn.lastModified, new Date());
   clone.lastMade = dateToFB(wgn.lastMade, new Date("2000-01-01"));
   if (wgn.id)
      return ref.doc(wgn.id).update(clone);
   else
      return ref.add(clone);
}

///Create Wagon Actual from Manual Wagon Data
function createWagonActual(state, data) {
   const ts = firebase.firestore.Timestamp.fromDate(new Date(data.prodTime));
   const wagon = state.Wagons.find(x => x.id == data.wagonId);
   const _prodKey = "WGN" + (new Date().getTime().toString(36)) + "-" + wagon.name;
   try {
      const _loadings = data.feeds.map((f, i) => {
         const feed = state.Feeds.find(x => x.Id == f.Id);
         return {
            dryMaterial: feed.dryMaterial,
            duration: 1,
            endTime: ts,
            feed: firebase.firestore().collection("/Users")
               .doc(state.user.uid).collection("/Feeds").doc(feed.Id),
            feedId: feed.Id,
            feedValue: feed.value,
            lineStatus: 5,
            loadOrder: i + 1,
            originalOrder: i + 1,
            qty: f.qty,
            qtyNeeded: f.qty,
            startTime: ts
         }
      });

      const _unloadings = wagon.groups.map((g, i) => {
         return {
            groupId: g.documentID,
            group: firebase.firestore().collection("/Users")
               .doc(state.user.uid).collection("/Groups").doc(g.documentID),
            startTime: ts,
            endTime: ts,
            duration: 1,
            grpCode: g.code,
            unloadedWeight: g.qty,
            qty: g.qty,
            status: 5,
            dailyPercent: g.dailyPercent,
            unloadOrder: i
         }
      });
      const _value = _loadings.reduce((sum, c) => sum + Number(c.feedValue) * Number(c.qty), 0);
      const _dry = _value > 0 ? _loadings.reduce((sum, c) => sum + Number(c.qty) * Number(c.dryMaterial), 0) / _value : 0;
      const _actual = {
         planWagonId: data.wagonId,
         wagonName: wagon.name,
         startTime: ts,
         startweight: 0,
         endTime: ts,
         tmrId: data.Id,
         tmrCode: data.code,
         status: 4,
         modified: ts,
         created: ts,
         loadDuration: 1,
         duration: 1,
         loadings: _loadings,
         unloadings: _unloadings,
         note: "_MANUAL_PROD_",
         tmrValue: _value,
         tmrDryMaterial: _dry
      };
      return firebase.firestore().collection('/Users')
         .doc(state.user.uid).collection("Actuals")
         .doc(_prodKey)
         .set(_actual)
   }
   catch (error) {
     // Fixme:console.error(error);
      return null
   }
}



